import { HttpService, HttpServiceResponse } from '../shared'
import { SecurityAction } from './security.constants'
export class SecurityProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/sec_view_api.php`
  }

  public get<T>(action: SecurityAction): Promise<HttpServiceResponse<T>> {
    let active = action === 'users' ? '&Active=2' : ''
    return this.http.post(`${this.url}?action=${action}${active}`)
  }
}
